<template>
  <div>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <div style="padding: 10px 10px">
          <v-tabs>
            <v-tabs-slider color="accent" />

            <v-tab
              v-for="title in tabTitles"
              :key="title"
            >
              {{ title }}
            </v-tab>

            <v-tab-item style="padding: 30px 10px 0">
              <v-text-field
                v-model="emailInput"
                outline
                label="Email"
                class="field"
                color="accent"
                style="width: 100%"
                :error-messages="emailError"
                :success="isEmailValid && emailInput !== email"
                @input="validateEmail"
              />

              <v-card-actions>
                <v-spacer />
                <v-btn
                  flat
                  :disabled="!canConfirmEmail"
                  @click="confirmEmail"
                >
                  Подтвердить
                </v-btn>
              </v-card-actions>
            </v-tab-item>

            <v-tab-item style="padding: 30px 10px 0">
              <v-text-field
                :value="email"
                outline
                label="Текущий email"
                readonly
                class="field"
                color="accent"
                style="width: 100%"
              />

              <v-card-actions>
                <v-spacer />
                <v-btn
                  flat
                  :disabled="!canConfirmVerification"
                  @click="confirmVerification"
                >
                  Подтвердить верификацию
                </v-btn>
              </v-card-actions>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import User from '../../../helpers/user'

export default {
  name: 'EmailModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    email: {
      type: String,
      default: ''
    },
    emailVerified: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialog: this.value,
      emailInput: '',
      emailError: '',
      tabTitles: ['Изменить почту', 'Верифицировать почту']
    }
  },
  computed: {
    canConfirmEmail () {
      return this.isEmailValid
        && this.emailInput
        && this.emailInput !== this.email
        && !this.emailError
    },
    canConfirmVerification () {
      return this.email && !this.emailVerified && User.hasAccess()
    },
    isEmailValid () {
      if (!this.emailInput) return false
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      return emailRegex.test(this.emailInput)
    }
  },
  watch: {
    value (newVal) {
      this.dialog = newVal
      if (newVal)
        this.resetForm()
    },
    dialog (newVal) {
      this.$emit('update:emailDialog', newVal)
      if (!newVal)
        this.resetForm()
    },
    email (newVal) {
      if (this.dialog)
        this.emailInput = newVal
    }
  },
  mounted () {
    this.resetForm()
  },
  methods: {
    validateEmail () {
      this.emailInput = this.emailInput ? this.emailInput.trim() : ''
      if (!this.emailInput) {
        this.emailError = 'Email не может быть пустым'
        return
      }

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!emailRegex.test(this.emailInput))
        this.emailError = 'Введите корректный email'
      else
        this.emailError = ''
    },
    confirmEmail () {
      if (!this.canConfirmEmail) return
      if (!User.hasAccess()) {
        this.$emit('show-error', 'Недостаточно прав для выполнения операции')
        return
      }

      this.dialog = false
      this.$emit('update:emailChanged', {
        email: this.emailInput.trim().toLowerCase()
      })
    },
    confirmVerification () {
      if (!this.canConfirmVerification) return
      if (!User.hasAccess()) {
        this.$emit('show-error', 'Недостаточно прав для выполнения операции')
        return
      }

      this.dialog = false
      this.$emit('update:emailChanged', {
        verification: true
      })
    },
    resetForm () {
      this.emailInput = this.email || ''
      this.emailError = ''
    }
  }
}
</script>

<style scoped>
.field {
  margin-top: 10px;
}
</style>
